var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavouriteFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_1407_72809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4578 10.5913C26.9691 10.0868 26.3889 9.68663 25.7503 9.41358C25.1117 9.14054 24.4272 9 23.7359 9C23.0446 9 22.3601 9.14054 21.7215 9.41358C21.0829 9.68663 20.5026 10.0868 20.0139 10.5913L18.9997 11.6379L17.9855 10.5913C16.9984 9.57276 15.6596 9.00053 14.2636 9.00053C12.8676 9.00053 11.5288 9.57276 10.5417 10.5913C9.55456 11.6099 9 12.9914 9 14.4319C9 15.8723 9.55456 17.2538 10.5417 18.2724L11.5559 19.3189L18.9997 27L26.4436 19.3189L27.4578 18.2724C27.9467 17.7681 28.3346 17.1694 28.5992 16.5105C28.8638 15.8515 29 15.1452 29 14.4319C29 13.7186 28.8638 13.0123 28.5992 12.3533C28.3346 11.6943 27.9467 11.0956 27.4578 10.5913Z",
    fill: "#EC187B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4578 10.5913C26.9691 10.0868 26.3889 9.68663 25.7503 9.41358C25.1117 9.14054 24.4272 9 23.7359 9C23.0446 9 22.3601 9.14054 21.7215 9.41358C21.0829 9.68663 20.5026 10.0868 20.0139 10.5913L18.9997 11.6379L17.9855 10.5913C16.9984 9.57276 15.6596 9.00053 14.2636 9.00053C12.8676 9.00053 11.5288 9.57276 10.5417 10.5913C9.55456 11.6099 9 12.9914 9 14.4319C9 15.8723 9.55456 17.2538 10.5417 18.2724L11.5559 19.3189L18.9997 27L26.4436 19.3189L27.4578 18.2724C27.9467 17.7681 28.3346 17.1694 28.5992 16.5105C28.8638 15.8515 29 15.1452 29 14.4319C29 13.7186 28.8638 13.0123 28.5992 12.3533C28.3346 11.6943 27.9467 11.0956 27.4578 10.5913Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1407_72809",
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1407_72809"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1407_72809",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteFilled);
export default __webpack_public_path__ + "static/media/favourite-filled.4e1579002d6c9ab55a31cccbaf37978e.svg";
export { ForwardRef as ReactComponent };